export default "__VITE_ASSET__BZxZZEwX__"